class BaseException extends Error{
    constructor(name, source, ...params){
        super(...params);
        this.name = name;
        this.source = source;
        // Object.setPrototypeOf(this, BaseException.prototype)
    }
}

export class MissingParameterException extends BaseException{
    constructor(source, paramList, ...params){
        super('MissingParameterException', source, ...params);
        this.details = JSON.stringify({requiredParameters: [...paramList]});
    }
}

export class InvalidValueException extends BaseException{
    constructor(source, param, invalidValue, validValues, ...params){
        super('InvalidValueException',source, ...params);
        this.details = JSON.stringify({
            invalidParameter: param,
            invalidValue: invalidValue,
            validValues: [...validValues]
        })
    }
}

export class UnauthorizedException extends BaseException{
    constructor(source, details, ...params){
        super('UnauthorizedException', source, ...params);
        this.details = JSON.stringify(details);
    }
}

export class InvalidTokenException extends BaseException{
    constructor(source, details, ...params){
        super('InvalidTokenException', source, ...params);
        this.details = JSON.stringify(`Token is ${details}`); //INVALID | EXPIRED
    }
}

export class InvalidSessionTypeException extends BaseException{
    constructor(source, validType,...params){
        super('InvalidSessionTypeException', source, ...params);
        this.details = JSON.stringify({validSessionType: validType});
    }
}

export class InvalidSessionStateException extends BaseException{
    constructor(source, details, ...params){
        super('InvalidSessionStateException', source, ...params);
        this.details = JSON.stringify(details);
    }
}

export class UnknownException extends BaseException{
    constructor(source, ...params){
        super('UnknownException', source, ...params);
        this.details = JSON.stringify('')
    }
}